import { create } from 'zustand';

export interface UserProfile {
  sub: string;
  email: string;
  /** 表示用ハンドル (英数 3〜10 文字)。 初回ログイン直後は null で、
   * フロントは /signup に誘導する。 */
  handle: string | null;
  avatar_url: string | null;
}

interface SessionState {
  me: UserProfile | null;
  loading: boolean;
  loadMe: () => Promise<void>;
  setHandle: (handle: string) => Promise<{ ok: true } | { ok: false; error: string }>;
  logout: () => Promise<void>;
}

export const useSession = create<SessionState>((set, get) => ({
  me: null,
  loading: false,
  loadMe: async () => {
    set({ loading: true });
    // タイムアウトで loading 固まりを防止。 4 秒で諦めて未認証扱い。
    const ac = new AbortController();
    const timer = setTimeout(() => ac.abort(), 4_000);
    try {
      const res = await fetch('/api/me', { credentials: 'include', signal: ac.signal });
      if (res.ok) {
        const me: UserProfile = await res.json();
        set({ me, loading: false });
      } else {
        set({ me: null, loading: false });
      }
    } catch {
      set({ me: null, loading: false });
    } finally {
      clearTimeout(timer);
    }
  },
  setHandle: async (handle) => {
    const res = await fetch('/api/me/handle', {
      method: 'PUT',
      credentials: 'include',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ handle }),
    });
    if (res.ok) {
      const data = (await res.json()) as { handle: string };
      const me = get().me;
      if (me) set({ me: { ...me, handle: data.handle } });
      return { ok: true };
    }
    if (res.status === 409) {
      return { ok: false, error: 'そのハンドルはすでに使われています' };
    }
    if (res.status === 400) {
      const txt = await res.text().catch(() => '');
      return { ok: false, error: txt || '使えない形式です' };
    }
    return { ok: false, error: `エラー: ${res.status}` };
  },
  logout: async () => {
    await fetch('/auth/logout', { method: 'POST', credentials: 'include' });
    set({ me: null });
  },
}));
